var _defs, _rect, _rect2, _rect3, _rect4, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnterpriseIntegrations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 8,
    y1: 8,
    x2: 50,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FE0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FB58F"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 10,
    width: 12,
    height: 12,
    rx: 3,
    fill: "url(#g1)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 10,
    width: 12,
    height: 12,
    rx: 3,
    fill: "url(#g1)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 36,
    width: 12,
    height: 12,
    rx: 3,
    fill: "url(#g1)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 36,
    width: 12,
    height: 12,
    rx: 3,
    fill: "url(#g1)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 9,
    fill: "url(#g1)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 16H24",
    stroke: "url(#g1)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 16H38",
    stroke: "url(#g1)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 42H24",
    stroke: "url(#g1)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34 42H38",
    stroke: "url(#g1)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22L24 25",
    stroke: "url(#g1)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40 22L34 25",
    stroke: "url(#g1)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18 36L24 33",
    stroke: "url(#g1)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40 36L34 33",
    stroke: "url(#g1)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25 29H33",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M29 25V33",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterpriseIntegrations);
export default __webpack_public_path__ + "static/media/Enterprise_Integrations.cbbdb1bb115501cc3c4b8007902813a2.svg";
export { ForwardRef as ReactComponent };